export default __webpack_public_path__ + "static/media/4875780_telegram_icon.4064db90.svg";